<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
          persistent
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar flat color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("farm.addNewUser")
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form
              ref="addUser"
              v-model="valid"
              lazy-validation
              autocomplete="off"
            >
              <v-card-text class="black--text">
                <div class="form">
                  <label for="name"
                    >{{ $t("name") }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    v-model="user.name"
                    :placeholder="$t('name')"
                    outlined
                    dense
                    :error-messages="errors.name"
                    :rules="rules.name"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="email"
                    >{{ $t("email") }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    v-model="user.email"
                    :placeholder="$t('user.emailAddr')"
                    outlined
                    dense
                    :error-messages="errors.email"
                    :rules="rules.email"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="mobile"
                    >{{ $t("mobileNum")
                    }}</label
                  >
                  <v-row no-gutters>
                        <v-col cols="3" class="">
                          <v-autocomplete
                            style="background-color: #1F5D51;"
                            outlined
                            :items="countries"
                            item-value="MobileCode"
                            class="phone-drop rounded-r-0 outline-l-0"
                            :filter="filterCountry"
                            dense
                            ref="phoneSelect"
                            hide-details
                            @change="phoneSelected"
                            v-model="user.countryCode"
                          >
                            <template v-slot:item="slotProps">
                                <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i> &nbsp;
                                {{` (+${slotProps.item.MobileCode }) ${slotProps.item.Name}` }}
                            </template>
                            <div class="truncate" slot="selection" slot-scope="data" style="color:white !important; font-size:12px; font-weight:bold;">
                                <span style="color:white !important;">
                                    <!-- <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>&nbsp; -->
                                    {{`( +${data.item.MobileCode } )` }}
                                </span>
                            </div>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="9">
                          <v-text-field
                            v-model="user.mobile"
                            :placeholder="$t('user.enterYourPhoneNumber')"
                            outlined
                            dense
                            class="rounded-l-0"
                          ></v-text-field>
                        </v-col>
                  </v-row>
                  
                </div>
                <div class="form">
                  <label for="password"
                    >{{ $t("password")
                    }}<span style="color: red">*</span></label
                  >
                  <v-text-field
                    :type="passwordType"
                    v-model="user.password"
                    :placeholder="$t('user.enterPassword')"
                    outlined
                    dense
                    :error-messages="errors.password"
                    autocomplete="on"
                    :append-icon="passwordIcon"
                    @click:append="changePasswordType"
                    :rules="rules.password"
                  ></v-text-field>
                </div>
                <div class="form">
                  <label for="department"
                    >{{ $t("department")
                    }}<span style="color: red">*</span></label
                  >
                  <v-select
                    v-model="user.department"
                    :items="departmentList"
                    item-text="name"
                    item-value="departmentNumber"
                    outlined
                    dense
                    :error-messages="errors.department"
                    @change="getRoles"
                    :rules="rules.department"
                    :placeholder="$t('farm.selectDept')"
                  ></v-select>
                </div>
                <div class="form">
                  <label for="role"
                    >{{ $t("role") }}
                    <span style="color: red">*</span>
                    <span class="caption" v-if="rolesList.length < 1"
                      >({{ $t("selectDepartmentWithActiveRoles") }})</span
                    >
                  </label>
                  <v-select
                    v-model="user.role"
                    :items="rolesList"
                    item-text="name"
                    item-value="roleNumber"
                    outlined
                    dense
                    :error-messages="errors.role"
                    :loading="roleLoading"
                    :rules="rules.role"
                    :placeholder="$t('farm.selectRole')"
                    :readonly="rolesList.length < 1"
                  ></v-select>
                  <!-- <span class="errorf">{{ errors.role }}</span> -->
                </div>
                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="closeModal"
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="saveUser"
                    right
                    height="44"
                    width="116"
                    color="primary"
                  >
                    {{ $t("submit") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <DataLostWarning
      :dialogI="dataLossWarning"
      v-if="dataLossWarning"
      @closeDialog="closeWarningMessage"
      @saveData="closeWarningMessage"
    ></DataLostWarning>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin";

import UserService from "@/_services/UserService";
import countries from "@/models/countries.js"

export default {
  created() {
    const fetchData = async () => {
      this.startLoading();
      this.departmentList = await this.getDepartments();
      const adminDeptIndex = this.departmentList.findIndex(
        (d) => d.name == "admin"
      );
      this.user.department = this.departmentList[adminDeptIndex].departmentNumber;

      this.rolesList = await this.getRolesList(this.user.department);
      const adminRolesIndex = this.rolesList.findIndex(
        (r) => r.name == "admin"
      );
      this.user.role = this.rolesList[adminRolesIndex].roleNumber;
      // this.departmentList = this.departmentList
      //   .filter(d => d.name == "admin")
      //   .map(d => ({ ...d, name: "LG COM" }));
      this.stopLoading();
    };
    fetchData();
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      // countryCode: '',
      // userMobile: '',
      countries,
      dataLossWarning: false,
      passwordType: "password",
      passwordIcon: "mdi-eye",
      valid: true,
      departmentList: [],
      rolesList: [],
      roleLoading: false,
      fieldType: { text: "text" },
      error: false,
      errors: {
        name: [],
        email: [],
        // mobile: [],
        password: [],
        department: [],
        role: [],
      },
      user: {
        name: "",
        email: "",
        countryCode: "",
        mobile: "",
        password: "",
        department: "",
        role: "",
      },
      rules: {
        name: [
          v => !!v || this.$t("nameIsRequired"),
          v => this.onlyAlpha(v) || this.$t("nameCanContainOnlyAlphabets"),
          v => (v && v.length <= 15) || this.$t("nameMustBeLessThan15Chars"),
        ],
        email: [
          v => !!v || this.$t('emailRequired'),
          v => (v.length < 1  || this.validateEmail(v)) || this.$t('invalidEmailFormat')
        ],
        countryCode: [
          v => !!v || this.$t('Country Code is required.'),
        ],
        // mobile: [
        //   v => !!v || this.$t('mobNumReq'),
        //   v => (v.length <= 12) || this.$t('Can\'t be more than 12 characters.'),
        //   // v => this.validMobileNumber(v) || this.$t('invalidMobFormat')
        // ],
        password: [v => !!v || this.$t("passwordRequired")],
        department: [v => !!v || this.$t("departmentReq")],
        role: [v => !!v || this.$t("roleReq")],
      },
    };
  },
  methods: {
    filterCountry(item, queryText){
      return item.Name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())
          ||  item.MobileCode.toString().includes(queryText.toLocaleLowerCase())

    },
    phoneSelected() {
			this.$refs.phoneSelect.blur();
		},
    closeWarningMessage(res) {
      console.log("ress", res);
      this.dataLossWarning = false;
      if (!res) {
        this.$emit("closeAddUser");
      }
    },
    changePasswordType() {
      console.log("test");
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye-off";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye";
      }
    },
    closeModal() {
      this.dataLossWarning = true;
      // this.$emit('closeAddUser')
    },
    saveUser() {
      // this.user.mobile = `${this.countryCode} ${this.userMobile}`
      this.emptyErrors();
      // if (!this.onlyAlpha(this.user.name)) {
      //   this.errors.name = "Name can contain only alphbets";
      //   this.error = true;
      // }
      // if (!this.user.email && !this.user.mobile) {
      //   this.errors.email = "Email or Mobile Number is required.";
      //   this.errors.mobile = "Email or Mobile Number is required.";
      //   this.error = true;
      // }
      // if (this.user.email && !this.validateEmail(this.user.email)) {
      //   this.errors.email = "Invalid email format.";
      //   this.error = true;
      // }
      // if(this.user.mobile && !this.validMobileNumber(this.user.mobile)) {
      //     this.errors.mobile = 'Invalid mobile number format.';
      //     this.error = true;
      // }
      // if (this.user.password.trim() == "") {
      //   this.errors.password = "Password can not be empty";
      //   this.error = true;
      // }
      // if (!this.user.department) {
      //   this.errors.department = "Department is required.";
      //   this.error = true;
      // }
      // if (!this.user.role) {
      //   this.errors.role = "Role is required.";
      //   this.error = true;
      // }
      // if (this.error) return;
      if (!this.$refs.addUser.validate()) return;
      // if (this.user.mobile || this.user.email) {
        this.startLoading();
        // this.user.mobile = this.user.mobile.replace(/ /g, "");
        // this.user.mobile = this.user.mobile.replace("+", "");
        UserService.addUser(this.user)
          .then(data => {
            if (data.success) {
              this.$emit("userAdded", { success: true, message: data.message });
            } else {
              if (data?.message?.errors?.length > 0) {
                data.message.errors.forEach(e => {
                  this.errors[e.param] = e.msg;
                });
              }
              this.$emit("userAdded", {
                success: false,
                message: data.message,
              });
            }
            this.$emit("closeAddUser");
            this.stopLoading();
          })
          .catch(err => {
            this.stopLoading();
            if (err?.response?.data?.message?.errors?.length > 0) {
              err.response.data.message.errors.forEach(e => {
                this.errors[e.param] = e.msg;
              });
            }
          });
      // } else {
      //   this.$notify({
      //     title: "Mobile Or Email Required ",
      //     text: "Please enter mobile or email",
      //     type: "error",
      //   });
      // }
    },

    emptyErrors() {
      this.error = false;
      this.errors.name = "";
      this.errors.email = "";
      // this.errors.mobile = "";
      this.errors.password = "";
      this.errors.department = "";
      this.errors.role = "";
    },
    async getRoles() {
      this.rolesList = [];
      this.roleLoading = true;
      this.rolesList = await this.getRolesList(this.user.department);
      // this.rolesList = this.rolesList
      //   .filter(d => d.name == "admin")
      //   .map(d => ({ ...d, name: "Admin" }));
      this.roleLoading = false;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [loadingMixin, generalMixin, PermissionsMixin],
};
</script>

<style>
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
  background: #ffffff !important;
  box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
  border-radius: 23px !important;
}
.custom-card .v-card__text {
  width: 100%;
  padding: 37px 60px !important;
}
.card-heading-1 {
  margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
  font-size: 30px;
  font-weight: 700;
}

.form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-size: 15px;
  font-family: Poppins-Medium;
}

.form span {
  color: red;
}
</style>
